import { render, staticRenderFns } from "./all-serial-v2.vue?vue&type=template&id=7607622d&"
import script from "./all-serial-v2.vue?vue&type=script&lang=js&"
export * from "./all-serial-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports